import BreadcrumbTitle from "components/BreadcrumbTitle"
import PageMetaTags from "components/PageMetaTags"
import React, { useEffect, useState } from "react"
import {
  Card,
  CardBody,
  Col,
  Container,
  Modal,
  Nav,
  NavLink,
  Row,
  Spinner,
  TabContent,
  TabPane,
} from "reactstrap"
import AxisCareReports from "./reports"
import AxisCareSettings from "./settings"
import { connect } from "react-redux"
import {
  downloadAxisCareReports,
  getAxisCareReports,
  getMetaTags,
  initAxisCare,
  resetAxisCareState,
  updateClientSettings,
} from "store/actions"

const AxisCare = ({
  metaTags,
  downloadAxisCareReports,
  initAxisCare,
  axisCareSetup,
  axisCareInitLoading,
  axisCareReports,
  vendorId,
  getMetaTags,
  getAxisCareReports,
  updateClientSettings,
  resetAxisCareState,
}) => {
  const TABS = {
    REPORTS: 1,
    SETTINGS: 2,
  }

  const [activeTab, setActiveTab] = useState(TABS.REPORTS)

  const markIfIsActive = tab => {
    return activeTab === tab ? "active" : ""
  }

  useEffect(() => {
    if (vendorId) {
      getMetaTags({})
      initAxisCare({ vendor_id: vendorId })
    }
  }, [vendorId])

  useEffect(() => {
    return () => {
      resetAxisCareState()
    }
  }, [])

  return (
    <React.Fragment>
      <div className="page-content">
        <PageMetaTags title="AxisCare" />
        <Container fluid>
          <BreadcrumbTitle title="AxisCare" breadcrumbItems={[]} />
          <Card>
            <CardBody>
              <Row>
                <Col>
                  <Nav pills tabs>
                    <NavLink
                      className={markIfIsActive(TABS.REPORTS)}
                      onClick={() => setActiveTab(TABS.REPORTS)}
                    >
                      {<span style={{ fontSize: "16px" }}>Reports</span>}
                    </NavLink>
                    <NavLink
                      className={markIfIsActive(TABS.SETTINGS)}
                      onClick={() => setActiveTab(TABS.SETTINGS)}
                    >
                      {<span style={{ fontSize: "16px" }}>Settings</span>}
                    </NavLink>
                  </Nav>
                  <TabContent activeTab={activeTab}>
                    <TabPane tabId={TABS.REPORTS}>
                      <AxisCareReports
                        tabIsActive={activeTab === TABS.REPORTS}
                        downloadAxisCareReports={downloadAxisCareReports}
                        axisCareReports={axisCareReports}
                        getAxisCareReports={getAxisCareReports}
                      />
                    </TabPane>
                    <TabPane tabId={TABS.SETTINGS}>
                      <AxisCareSettings
                        metaTags={metaTags}
                        tabIsActive={activeTab === TABS.SETTINGS}
                        axisCareSetup={axisCareSetup}
                        updateClientSettings={updateClientSettings}
                      />
                    </TabPane>
                  </TabContent>
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Container>
      </div>
      <Modal isOpen={axisCareInitLoading} centered={true} size="sm">
        <CardBody className={"p-2 my-1 text-center"}>
          <Spinner className="ms-2" color="primary" />
        </CardBody>
      </Modal>
    </React.Fragment>
  )
}

const mapStateToProps = state => ({
  metaTags: state.Tags.metaTags,
  axisCareInitLoading: state.AxisCare.axisCareInitLoading,
  axisCareReports: state.AxisCare.axisCareReports,
  axisCareSetup: state.AxisCare.axisCareSetup,
  vendorId: state.Login.vendorId,
})

const mapDispatchToProps = dispatch => ({
  downloadAxisCareReports: values => dispatch(downloadAxisCareReports(values)),
  initAxisCare: values => dispatch(initAxisCare(values)),
  getMetaTags: values => dispatch(getMetaTags(values)),
  getAxisCareReports: values => dispatch(getAxisCareReports(values)),
  updateClientSettings: values => dispatch(updateClientSettings(values)),
  resetAxisCareState: () => dispatch(resetAxisCareState()),
})

export default connect(mapStateToProps, mapDispatchToProps)(AxisCare)
